var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 19.4C17.5 19.7038 17.286 19.9548 17.0084 19.9946L16.9312 20L7.0688 20C6.75467 20 6.5 19.7314 6.5 19.4C6.5 19.0962 6.71402 18.8452 6.99167 18.8054L7.0688 18.8L16.9312 18.8C17.2453 18.8 17.5 19.0686 17.5 19.4ZM16.132 12.5176L16.1958 12.5757C16.3977 12.7887 16.4161 13.1221 16.2508 13.357L16.1958 13.4243L12.4055 17.4216C12.2037 17.6345 11.8879 17.6539 11.6652 17.4798L11.6014 17.4218L7.80674 13.4245C7.58445 13.1903 7.58422 12.8104 7.8062 12.5759C8.00802 12.3628 8.32397 12.3432 8.54679 12.5173L8.61064 12.5754L11.4297 15.5441L11.429 4.60001C11.429 4.29624 11.643 4.04521 11.9206 4.00548L11.9978 4C12.2857 4 12.5237 4.22572 12.5614 4.51859L12.5666 4.60001L12.5673 15.5545L15.3914 12.5756C15.5934 12.3626 15.9094 12.3433 16.132 12.5176L16.1958 12.5757L16.132 12.5176Z",
    fill: "#96C11F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportIcon);
export default __webpack_public_path__ + "static/media/ImportIcon.c504ce4adeae45a445b4485618942861.svg";
export { ForwardRef as ReactComponent };